module.exports = __webpack_public_path__ + "img/adminVideo-1.2880dbc5.png";